import React from 'react';

import AboutSection from '@components/about-section';
import Layout from '@components/layout';
import HeroSection from '@components/hero-section';
import company from '@data/company.json';

const BetonaraPage = () => (
  <Layout pagePath="/proizvodnja-i-prodaja-betona" pageTitle="Proizvodnja i prodaja betona" pageDescription="Proizvodnja svježe betonske mješavine sa transportom i ugradnjom.">
    <HeroSection cn="pipb">
      <h1>Proizvodnja i prodaja betona</h1>
    </HeroSection>
    <AboutSection>
      <p>
        Preduzeće Keso-Promet d.o.o. za proizvodnju betona koristi svoju jednu
        betonsku bazu.
      </p>
      <p>
        Radni kapaciteti fabrike je 60m³/h svježe betonske mešavine. Za
        transport i ugradnju betona kompanija poseduje kamion mikser kapaciteta
        4-12m³ betona, kao i beton pumpe koje se nalaze u sklopu miksera.
      </p>
      <p>Za više informacija možete nas pozvati na broj <a href={`tel:${company.divisions.betonara.phone.replace(/[\s-]/g, '')}`}>{company.divisions.betonara.phone}</a>.</p>
    </AboutSection>
  </Layout>
);

export default BetonaraPage;
